import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMap } from 'react-leaflet';

import { visibleMarkersMapSelector, markerDetailViewSelector, markersSelector } from '../../../features/places/placesSlice';
import { setNeedBounding, setCenter, setZoom, resetMapDefault } from '../../../features/map/mapSlice';

const OsmMapMarkerBounder = () => {
    const dispatch = useDispatch();
    const visibleMarkersMap = useSelector(visibleMarkersMapSelector);
    const markerDetailView = useSelector(markerDetailViewSelector);
    const markers = useSelector(markersSelector)
    const map = useMap();


    useEffect(() => {
        const mapBounder = () => {
            if (map && !markerDetailView) {
                if (visibleMarkersMap.length > 1) {
                    let pointArray = [];
                    visibleMarkersMap.forEach(vz => {
                        if (markers[`${vz}`]) {
                            pointArray.push([
                                parseFloat(markers[`${vz}`].marker_coords.lat),
                                parseFloat(markers[`${vz}`].marker_coords.lng),
                            ])
                        }

                    });
                    map.fitBounds(pointArray, { paddingTopLeft: [350, 75], paddingBottomRight: [25, 100] });
                } else if (visibleMarkersMap.length === 1) {
                    dispatch(setCenter({
                        lat: parseFloat(markers[`${visibleMarkersMap[0]}`].marker_coords.lat),
                        lng: parseFloat(markers[`${visibleMarkersMap[0]}`].marker_coords.lng),
                    }));
                    dispatch(setZoom(17));
                } else {
                    dispatch(resetMapDefault());
                }
                dispatch(setNeedBounding(false));
            };
        };
        mapBounder();
    }, [dispatch, map, visibleMarkersMap, markerDetailView, markers]);

    return (
        <div></div>
    );
}

export default OsmMapMarkerBounder;